"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_HOLIDAYS_MAP = void 0;
const date_holidays_1 = __importDefault(require("date-holidays"));
const enums_1 = require("@bemlo/enums");
const sweden_1 = require("./sweden");
exports.COUNTRY_HOLIDAYS_MAP = {
    [enums_1.Country.SWEDEN]: [() => new date_holidays_1.default('SE'), sweden_1.SWEDISH_HOLIDAYS],
};
